// src/videos/streamVideos.js

// Your Stream “customer subdomain”
export const CF_STREAM_CUSTOMER =
  "customer-4jl2c1cwzsz2xmhc.cloudflarestream.com";

// Keep ALL Stream video IDs here (one source of truth)
export const STREAM_VIDEOS = {
  // ✅ Level 1 (NEW — Doron Battle Intro)
  L1_DORON_BATTLE_INTRO: {
    id: "cb1cb4fbf84c912e5f11e5c215b00d5e",
    title: "Level 1 - Doron Battle (Intro)",
  },

  // ✅ Level 2
  L2_ZEB_INTRO: {
    id: "bc8be6bf59af3855bbcc7008bb22806b",
    title: "Level 2 - Zeb’s Birthday (Intro)",
  },
  L2_BLACK_KEYS: {
    id: "c66058cf213a3b1dbd77c1bc7a99c8c9",
    title: "Level 2 - Learn Black Keys",
  },

  // ✅ Level 3 (UPDATED ID — captions added)
  L3_PENG_INTRO: {
    id: "3089ef96311a65e8601c96b4692d89d9",
    title: "Level 3 - Ode to Joy (Peng)",
  },

  // ✅ Level 4
  L4_INTRO: {
    id: "cb2e9736003ffefa9252f6ce1f926c8d",
    title: "Level 4 - Treb Lake (Machli Star)",
  },

  // ✅ Level 5
  L5_INTRO: {
    id: "48733fca9845bfcddbf5804dd16331f6",
    title: "Level 5 - Ren (Reindeer Star)",
  },

  // ✅ Level 6
  L6_SPIDER_INTRO: {
    id: "fe0b608ee5d194e1c728f26821db230d",
    title: "Level 6 - Spider Dance (Incy Wincy)",
  },

  // ✅ Level 7
  L7_LONDON_INTRO: {
    id: "e5d66b9df96f27e3363d5a871c00cf6b",
    title: "Level 7 - London Bridge",
  },

  // ✅ Level 8
  L8_ANTHEM_INTRO: {
    id: "740a221ddca0f86126bf121a6b2afdfc",
    title: "Level 8 - Jana Gana Mana (Peacock Star)",
  },

  // ✅ Level 9
  L9_CROC_INTRO: {
    id: "1e6e779318ac1b668754fe03b4850846",
    title: "Level 9 - Row Row Row Your Boat (Crocodile Star)",
  },

  // ✅ Level 10 (FINAL)
  L10_FINAL_BATTLE_INTRO: {
    id: "2c43e4070a846c305c4b71a31e8c92dd",
    title: "Level 10 - Final Doron Battle (Intro)",
  },
};

// Helper to build the Cloudflare Stream iframe URL
export function streamIframeUrl(videoId) {
  return `https://${CF_STREAM_CUSTOMER}/${videoId}/iframe`;
}
